import env from 'env/env';
import interpolate from 'utils/interpolate';

export const buildPath = (
  {
    johnLewis = false,
    loyaltyExperiences = false,
    johnLewisGifting = false,
    walletPasses = false,
    defaultVersion = 1,
    endpoint,
    service,
  } = {},
  args,
) => {
  if (!johnLewisGifting && (!endpoint || !service)) return '/';

  const path = typeof endpoint === 'function' ? endpoint(args) : interpolate(endpoint, args);
  const { version = defaultVersion } = args;

  if (johnLewisGifting) {
    return `/v${version}/${path}`;
  }

  if (johnLewis || loyaltyExperiences || walletPasses) {
    return `/${service}/v${version}/${path}`;
  }

  return `/${service}-${env.apiEnv}/v${version}/${path}`;
};
